export default __webpack_public_path__ + "static/media/BrandLive_Logo_light.91e3b695.svg";